import { render, staticRenderFns } from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=template&id=42857b2f&scoped=true&"
import script from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=script&lang=js&"
export * from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=style&index=0&id=42857b2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42857b2f",
  null
  
)

export default component.exports